import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/es';
import { TextInput } from '../textInput/TextInput';
import moment from 'moment';

import './timeInput.scss';
const locale = "es-ES";
export const TimeInput = ({
    onChange,
    label,
    value,
    name,
    disabled = false,
    ...props
}) => {

    const dateValue = value && moment(value, 'HH:mm')._isValid ? moment(value, 'HH:mm') : null;

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} locale={locale}>
            <TimePicker
                label={label}
                value={dateValue}
                disabled={disabled}
                size='small'
                name={name}
                className='time-input'
                onChange={onChange}
                renderInput={(params) =>
                    <TextInput
                        {...props}
                        size='small'
                        fullWidth
                        variant="outlined"
                        className="date-input"
                        style={{ backgroundColor: 'white' }}
                        error={false}
                        {...params}
                    />
                }
            />
        </LocalizationProvider>
    )
}